import { useEffect, useState } from "react";
import { motion } from "motion/react";
import { isMobile } from "react-device-detect";

export interface StudioIconProps {
  className: string;
}
const StudioIcon = ({ className }: StudioIconProps) => {
  const [startSecondAnimation, setStartSecondAnimation] = useState<boolean>(false);

  useEffect(() => {
    const secondAnimation = setTimeout(() => {
      setStartSecondAnimation(true);
    }, 2100);

    return () => {
      clearTimeout(secondAnimation);
    };
  }, []);

  return (
    <div
      className={`grid grid-cols-1 grid-rows-1 col-span-2 col-start-2 w-full h-full ${className}`}
    >
      <motion.svg
        xmlns="http://www.w3.org/2000/svg"
        {...(!isMobile ? { width: 487, height: 495 } : { width: 200, height: 203.285 })}
        viewBox="0 0 487 495"
        className={`col-start-1 row-start-1 max-h-[500px] lg:max-h-[400px] xl:max-h-[400px] 3xl:max-h-[500px] `}
      >
        <motion.path
          d="M236.663 11.0897L242.802 8L207.505 57.4352L256.614 29.6279L153.792 125.409L271.96 55.8904L8 241.272L288.842 77.5183L40.2277 267.535L313.396 108.415L70.9208 287.618L336.416 133.133L103.149 313.88L364.04 162.485L123.099 332.419L385.525 179.478L143.05 352.502L408.545 198.017L167.604 378.764L440.772 221.189L189.089 405.027L473 239.728L204.436 423.565L353.297 337.053L218.248 446.738L296.515 400.392L235.129 473L253.545 462.186"
          stroke={"white"}
          strokeWidth="16"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="#fff"
          initial={{
            pathLength: 0,
            fill: "rgba(255,255,255,0)",
          }}
          animate={{
            pathLength: 1,
            fill: "rgba(255,255,255,0)",
          }}
          transition={{
            duration: 2,
            ease: "easeInOut",
          }}
        />

        <motion.path
          d="M236.663 11.0897L242.802 8L207.505 57.4352L256.614 29.6279L153.792 125.409L271.96 55.8904L8 241.272L288.842 77.5183L40.2277 267.535L313.396 108.415L70.9208 287.618L336.416 133.133L103.149 313.88L364.04 162.485L123.099 332.419L385.525 179.478L143.05 352.502L408.545 198.017L167.604 378.764L440.772 221.189L189.089 405.027L473 239.728L204.436 423.565L353.297 337.053L218.248 446.738L296.515 400.392L235.129 473L253.545 462.186"
          stroke="#EC494A"
          strokeWidth="16"
          strokeLinecap="round"
          strokeLinejoin="round"
          initial={{
            clipPath: "inset(0 0 100% 0)",
          }}
          animate={
            startSecondAnimation
              ? {
                  clipPath: "inset(0 0 0% 0)",
                }
              : {}
          }
          transition={{
            duration: 1.5,
            ease: "linear",
          }}
        />
      </motion.svg>
    </div>
  );
};
export default StudioIcon;
